var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 390",
    style: {
      enableBackground: "new 0 0 500 390"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A7A7A7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.4,19.3c-8.7-8.8-20.8-14.2-34.2-14.2H50.8c-13.3,0-25.4,5.4-34.2,14.2C7.9,28,2.5,40.1,2.5,53.4v283.2 c0,13.3,5.4,25.4,14.1,34.1c8.7,8.8,20.8,14.2,34.2,14.2h398.3c13.3,0,25.4-5.4,34.1-14.1c8.8-8.7,14.2-20.8,14.2-34.2V53.4 C497.5,40.1,492.1,28,483.4,19.3z M457.5,316.6L335.9,195L457.5,73.4V316.6z M193.2,222.6l43.7,43.3c1.9,1.9,4.2,3.4,6.6,4.4 c2.4,1,4.9,1.5,7.5,1.5c2.6,0,5.1-0.5,7.5-1.5c2.4-1,4.7-2.5,6.6-4.4l42.5-42.5l121.6,121.6H70.8L193.2,222.6z M71.1,45.1h358.1 L250.9,223.4L71.1,45.1z M164.7,194.4L42.5,316.6V73.2L164.7,194.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.d07e71403db0b931779212fc2154bba0.svg";
export { ForwardRef as ReactComponent };